import React from 'react';
import {
  Alert,
  AlertDescription,
  ButtonGroup,
  Button,
} from '@zapier/design-system';

type Props = {
  msg: string;
  onCancel: () => void;
  onRetry: () => void;
};

export const RetryableError = (props: Props) => {
  return (
    <Alert layout="modal" title="An Error Occurred" type="error">
      <AlertDescription>{props.msg}</AlertDescription>
      <ButtonGroup justify="center">
        <Button color="secondary" onClick={props.onCancel} size="small">
          Cancel
        </Button>
        <Button onClick={props.onRetry} size="small">
          Try Again
        </Button>
      </ButtonGroup>
    </Alert>
  );
};
